import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtL, fmtDate, apiErr } from "@/lib/format";
import { toast } from "sonner";
import { useModalForm } from "@/lib/modalForm";
import BotonCerrar from "@/components/BotonCerrar";
import { PlusIcon } from "@phosphor-icons/react";

// Préstamos / adelantos de sueldo a empleados: se descuentan por cuota en la planilla.
export default function LoansPanel() {
  const [rows, setRows] = useState([]);
  const [emps, setEmps] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ empleado_id: "", monto: "", cuota: "", motivo: "", cuenta_id: "" });
  const load = () => api.get("/hr/loans").then(({ data }) => setRows(data || [])).catch(() => {});
  useEffect(() => {
    load();
    api.get("/hr/employees", { params: { estado: "activo" } }).then(({ data }) => setEmps(data || [])).catch(() => {});
    api.get("/treasury/accounts").then(({ data }) => setAccounts(data || [])).catch(() => {});
  }, []);
  const save = async () => {
    try {
      await api.post("/hr/loans", { ...f, monto: Number(f.monto), cuota: Number(f.cuota), cuenta_id: f.cuenta_id || null });
      toast.success("Préstamo registrado"); setOpen(false); setF({ empleado_id: "", monto: "", cuota: "", motivo: "", cuenta_id: "" }); load();
    } catch (e) { toast.error(apiErr(e)); }
  };
  const inp = "w-full bg-app border border-border rounded px-2 py-1.5 text-sm";
  const m = useModalForm({ value: f, abierto: open, onClose: () => setOpen(false), onSave: save });
  return (
    <div className="bg-card border border-border/60 rounded-lg overflow-hidden" data-testid="loans-panel">
      <div className="p-3 border-b border-border/60 flex justify-between items-center">
        <h3 className="font-heading text-sm">Préstamos a empleados</h3>
        <button onClick={() => setOpen(true)} className="text-xs flex items-center gap-1 px-2 py-1 bg-agro-green text-black font-medium rounded" data-testid="new-loan"><PlusIcon size={12} /> Nuevo</button>
      </div>
      <table className="w-full text-xs">
        <thead className="bg-sidebar/60"><tr className="text-[10px] uppercase text-text-muted text-left"><th className="p-2">N°</th><th className="p-2">Empleado</th><th className="p-2 text-right">Monto</th><th className="p-2 text-right">Cuota</th><th className="p-2 text-right">Saldo</th><th className="p-2">Estado</th></tr></thead>
        <tbody>{rows.length === 0 ? <tr><td colSpan="6" className="p-4 text-center text-text-muted">Sin préstamos</td></tr> : rows.map((r) => (
          <tr key={r.id} className="border-t border-border/30"><td className="p-2 font-mono">{r.numero}<div className="text-[10px] text-text-muted">{fmtDate(r.fecha)}</div></td><td className="p-2">{r.empleado_nombre}</td>
            <td className="p-2 text-right">{fmtL(r.monto)}</td><td className="p-2 text-right">{fmtL(r.cuota)}</td><td className="p-2 text-right text-agro-yellow">{fmtL(r.saldo)}</td><td className="p-2 uppercase text-[10px]">{r.estado}</td></tr>
        ))}</tbody>
      </table>
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" {...m.overlayProps}>
          <div className="bg-card border border-border rounded-lg w-full max-w-md">
            <div className="p-4 border-b border-border flex justify-between"><h3 className="font-heading text-lg">Nuevo préstamo a empleado</h3><BotonCerrar onClick={m.cerrar} /></div>
            <div className="p-4 space-y-2">
              <select value={f.empleado_id} onChange={(e) => setF({ ...f, empleado_id: e.target.value })} className={inp} data-testid="loan-emp">
                <option value="">— Empleado —</option>{emps.map((e) => <option key={e.id} value={e.id}>{e.nombre} ({e.codigo})</option>)}
              </select>
              <div className="grid grid-cols-2 gap-2">
                <input type="number" placeholder="Monto (L)" value={f.monto} onChange={(e) => setF({ ...f, monto: e.target.value })} className={inp} data-testid="loan-monto" />
                <input type="number" placeholder="Cuota por planilla (L)" value={f.cuota} onChange={(e) => setF({ ...f, cuota: e.target.value })} className={inp} data-testid="loan-cuota" />
              </div>
              <select value={f.cuenta_id} onChange={(e) => setF({ ...f, cuenta_id: e.target.value })} className={inp}>
                <option value="">— Caja por defecto —</option>{accounts.map((a) => <option key={a.id} value={a.id}>{a.codigo} · {a.nombre}</option>)}
              </select>
              <input placeholder="Motivo" value={f.motivo} onChange={(e) => setF({ ...f, motivo: e.target.value })} className={inp} />
              <p className="text-[11px] text-text-muted">Asiento: Dr 1112 Préstamos a empleados / Cr caja-banco. La cuota se deduce automáticamente al calcular la planilla.</p>
            </div>
            <div className="p-4 border-t border-border flex justify-end gap-2">
              <button onClick={m.cerrar} className="px-3 py-1.5 text-sm border border-border rounded">Cancelar</button>
              <button onClick={m.guardar} disabled={m.saving || !(f.empleado_id && Number(f.monto) > 0 && Number(f.cuota) > 0)} title="Empleado, monto y cuota son obligatorios" className="px-4 py-1.5 text-sm bg-agro-green text-black font-medium rounded disabled:opacity-40" data-testid="loan-save">{m.saving ? "Guardando…" : "Entregar"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
